import NOTIFICATION_CONFIG from "../Enums/NotificationConfig";

export default (customOptions = {}) => {
  return {
    ...NOTIFICATION_CONFIG,
    ...customOptions,
  };
};
